import React, { useState, useEffect } from 'react';
import {Row, Col, Card, CardBody, CardHeader, FormGroup, Modal} from 'reactstrap';
import VerticalLabel from 'views/pages/components/VerticalLabel'
import moment from 'moment';
import {formatDateShortGB} from '@constants/index';
import {ButtonContainer} from "@pages/reusable-components/styled-components";
import InputCustom from 'views/pages/components/InputCustom'
import {InputArraySelect} from 'views/pages/components/InputSelect'

interface VehicleDetailsProps {
    initialVehicle: any;
    filteredModels: any;
    makes: any;
    getVehicleData: () => void;
    updateVehicle: (vehicle?: any, callback?: () => void) => void;
    selectMake: (id: string | number) => void;
}

const VehicleDetails: React.FC<VehicleDetailsProps> = ({
                                                           initialVehicle,
                                                           getVehicleData,
                                                           updateVehicle,
                                                           selectMake,
                                                           makes,
                                                           filteredModels
                                                       }) => {
    const [vehicle, setVehicle] = useState<any>({});

    const [updateVehicleModal, setUpdateVehicleModal] = useState<{
        show: boolean;
        header: string | any;
        key: string | any;
    }>({
        show: false,
        header: '',
        key: ''
    })

    const [updateMakeModelModal, setUpdateMakeModelModal] = useState({
        show: false,
    })

    const [updateVehicleEnable, setUpdateVehicleEnable] = useState<boolean>(true)

    useEffect(() => {
        if (initialVehicle && Object.keys(initialVehicle).length) {
            setVehicle(initialVehicle);
        }
    }, [initialVehicle]);

    // @ts-ignore
    return (
        <CardBody>
            <Modal
                isOpen={updateVehicleModal.show}
                toggle={() => setUpdateVehicleModal({
                    ...updateVehicleModal,
                    show: false
                })}
                className="modal-dialog-centered"
            >
                <div className="modal-header ">
                    <h6 className="modal-title">{`${updateVehicleModal.header} update`}</h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setUpdateVehicleModal({
                            ...updateVehicleModal,
                            show: false
                        })}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body" style={{ paddingBottom: 0 }}>
                    <InputCustom
                        newLabel={updateVehicleModal.header}
                        value={vehicle && vehicle[updateVehicleModal.key] ? vehicle[updateVehicleModal.key] : ''}
                        onChange={e => {
                            setVehicle({
                                ...vehicle,
                                [updateVehicleModal.key]: e.target.value
                            })
                        }}
                    />
                </div>
                <div className="modal-footer justify-content-end" style={{ paddingTop: 0 }}>
                    <ButtonContainer
                        reverse={true}
                        onClick={() => {
                            setUpdateVehicleEnable(false)
                            updateVehicle(vehicle, () => {
                                setUpdateVehicleEnable(true)
                                setUpdateVehicleModal({show: false})
                            })
                        }}
                    >
                        {`Save`}
                    </ButtonContainer>
                </div>
            </Modal>
            <Modal
                isOpen={updateMakeModelModal.show}
                toggle={() => setUpdateMakeModelModal({
                    ...updateMakeModelModal,
                    show: false
                })}
                className="modal-dialog-centered"
            >
                <div className="modal-header">
                    <h6 className="modal-title">{`Make/Model update`}</h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => setUpdateMakeModelModal({
                            ...updateMakeModelModal,
                            show: false
                        })}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body" style={{ paddingBottom: 0 }}>
                    <InputArraySelect
                        newLabel={`Make`}
                        value={vehicle && vehicle.redundant_vehicle_make_id ? vehicle.redundant_vehicle_make_id : ''}
                        options={makes}
                        onChange={e => {
                            setVehicle({
                                ...vehicle,
                                redundant_vehicle_make_id: e.target.value,
                            })
                            selectMake(e.target.value)
                        }}
                        valueKey={`id`}
                        labelKey={`name`}
                        defaultOption={true}
                    />
                    <InputArraySelect
                        newLabel={`Vehicle model`}
                        value={vehicle && vehicle.vehicle_model_id ? vehicle.vehicle_model_id : ''}
                        options={filteredModels}
                        onChange={e => setVehicle({
                            ...vehicle,
                            vehicle_model_id: e.target.value,
                        })}
                        valueKey={`id`}
                        labelKey={`name`}
                        defaultOption={true}
                    />
                </div>
                <div className="modal-footer  justify-content-end" style={{ paddingTop: 0 }}>
                    <ButtonContainer
                        reverse
                        onClick={() => {
                            setUpdateVehicleEnable(false)
                            updateVehicle(vehicle, () => {
                                setUpdateVehicleEnable(true)
                                setUpdateMakeModelModal({show: false})
                            })
                        }}
                    >
                        {`Save`}
                    </ButtonContainer>
                </div>
            </Modal>
            <Row className="mt-4">
                <Col md={9} sm={12}>

                </Col>
                <Col md={3} sm={12}>
                    <ButtonContainer onClick={() => getVehicleData()}>Get Vehicle Data</ButtonContainer>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={12}>
                    <h2>{`Vehicle registration`}</h2>
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`Make`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.vehicle_make && vehicle.vehicle_make.name ? `${vehicle.vehicle_make.name.toUpperCase()}` : ` `
                            }}
                            onClick={() => {
                                setUpdateMakeModelModal({
                                    ...updateMakeModelModal,
                                    show: true,
                                })
                                selectMake(vehicle.vehicle_make.id ? vehicle.vehicle_make.id : '-')
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`Model`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.vehicle_model && vehicle.vehicle_model.name ? `${vehicle.vehicle_model.name.toUpperCase()}` : ` `
                            }}
                            onClick={() => {
                                setUpdateMakeModelModal({
                                    ...updateMakeModelModal,
                                    show: true,
                                })
                                selectMake(vehicle.vehicle_model.id ? vehicle.vehicle_model.id : '-')
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Status`} value={vehicle && vehicle.status ? `${vehicle.status.toUpperCase()}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`Derivative`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.derivative ? `${vehicle.derivative.toUpperCase()}` : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                            }}
                            onClick={() => {
                                setUpdateVehicleModal({
                                    ...updateVehicleModal,
                                    show: true,
                                    header: 'Derivative',
                                    key: 'derivative'
                                })
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`Mileage`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.current_mileage ? `${vehicle.current_mileage}` : ` `
                            }}
                            onClick={() => {
                                setUpdateVehicleModal({
                                    ...updateVehicleModal,
                                    show: true,
                                    header: 'Mileage',
                                    key: 'current_mileage'
                                })
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`VRM`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.stock_no ? `${vehicle.stock_no.toUpperCase()}` : ` `
                            }}
                            onClick={() => {
                                setUpdateVehicleModal({
                                    ...updateVehicleModal,
                                    show: true,
                                    header: 'VRM',
                                    key: 'stock_no'
                                })
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Full VIN`} value={vehicle && vehicle?.features?.full_vin ? `${vehicle?.features.full_vin.toUpperCase()}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Engin number`} value={vehicle && vehicle?.features?.engine_number ? `${vehicle?.features.engine_number.toUpperCase()}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`First registered`} value={vehicle && vehicle?.features?.first_registered ? formatDateShortGB(vehicle?.features.first_registered) : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`First registered UK`} value={vehicle && vehicle?.features?.first_registered_uk ? formatDateShortGB(vehicle?.features.first_registered_uk) : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Year manufacture`} value={vehicle && vehicle?.features?.year_manufacture ? vehicle?.features.year_manufacture : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <FormGroup>
                        <label style={{
                            fontSize: '16px',
                            fontWeight: 400,
                            borderBottom: '1px solid #c0c0c0',
                            color: '#2d2d2d',
                            lineHeight: '16px'
                        }}>
                            {`Color`}
                        </label>
                        <div
                            style={{
                                fontWeight: '600',
                                fontSize: '16px',
                                color: '#414141',
                                cursor: 'pointer',
                                textDecorationLine: 'underline',
                                textDecorationStyle: 'dotted'
                            }}
                            dangerouslySetInnerHTML={{
                                __html: vehicle && vehicle.colour ? `${vehicle.colour.toUpperCase()}` : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                            }}
                            onClick={() => {
                                setUpdateVehicleModal({
                                    ...updateVehicleModal,
                                    show: true,
                                    header: 'Color',
                                    key: 'colour'
                                })
                            }}
                        >
                        </div>
                    </FormGroup>
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Gearbox`} value={vehicle?.features?.vehicle_gear?.name.toUpperCase() ?? ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Forward gears`} value={vehicle && vehicle.features?.gears_number ? `${vehicle.features.gears_number} gears` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Fuel`} value={vehicle?.features?.vehicle_fuel?.name?.toUpperCase() ?? ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Engine capacity`} value={vehicle && vehicle.features?.engine_capacity ? `${vehicle.features.engine_capacity}cc` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Door plan`} value={vehicle && vehicle.features?.door_plan ? `${vehicle.features.door_plan.toUpperCase()}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Seating capacity`} value={vehicle && vehicle.features?.seating_capacity ? `${vehicle.features.seating_capacity} seats` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`CO2`} value={vehicle && vehicle.features?.co2 ? `${vehicle.features.co2}g/km` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Kerb weight`} value={vehicle && vehicle.features?.kerb_weight ? `${vehicle.features.kerb_weight}kg` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`VIN last 5`} value={vehicle && vehicle.features?.vin_last_5 ? `${vehicle.features.vin_last_5}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Scrapped`} value={vehicle && vehicle.features?.scrapped ? `${vehicle.features.scrapped}` : `NO`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Date scrapped`} value={vehicle && vehicle.features?.date_scrapped ? `${vehicle.features.date_scrapped}` : `Not scrapped`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Exported`} value={vehicle && vehicle.features?.exported ? `${vehicle.features.exported}` : `NO`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Date exported`} value={vehicle && vehicle?.features?.date_exported ? `${vehicle.features.date_exported}` : `Not exported`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Imported`} value={vehicle && vehicle?.features?.imported ? `${vehicle.features.imported}` : `NO`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Imported Non EU`} value={vehicle && vehicle?.features?.imported_non_eu ? `${vehicle.features.imported_non_eu}` : `NO`} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Euro status`} value={vehicle && vehicle.features?.euro_status ? `${vehicle.features.euro_status}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Driven Axle`} value={vehicle && vehicle.features?.driven_axle ? `${vehicle.features.driven_axle}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Type approval`} value={vehicle && vehicle.features?.type_approval ? `${vehicle.features.type_approval}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Vehicle Class`} value={vehicle && vehicle.features?.vehicle_class ? `${vehicle.features.vehicle_class}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Total keepers`} value={vehicle && vehicle.features?.total_keepers ? `${vehicle.features.total_keepers}` : ` `} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`Colour changes`} value={vehicle && vehicle.features?.colour_changes ? `${vehicle.features.colour_changes}` : 0} />
                </Col>
                <Col md={3} sm={12}>
                    <VerticalLabel label={`V5 certificates`} value={vehicle && vehicle.features?.v5_certificates ? `${vehicle.features.v5_certificates}` : ` `} />
                </Col>
            </Row>
            <Row className="mt-4">
                <Col md={12}>
                    <h2>{`Technical Data`}</h2>
                </Col>
                <Col md={6} sm={12}>
                    <Card>
                        <CardHeader>
                            <h2 className="mb-0 main-color">{`Weights & Dimensions`}</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Kerb weight`} value={vehicle && vehicle.features?.kerb_weight ? `${vehicle.features.kerb_weight}<sup>kg</sup>` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Gross weight`} value={vehicle && vehicle.features?.gross_weight ? `${vehicle.features.gross_weight}<sup>kg</sup>` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Length`} value={vehicle && vehicle.features?.length ? `${vehicle.features.length}<sup>mm</sup>` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Height`} value={vehicle && vehicle.features?.height ? `${vehicle.features.height}<sup>mm</sup>` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Width`} value={vehicle && vehicle.features?.width ? `${vehicle.features.width}<sup>mm</sup>` : ` `} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} sm={12}>
                    <Card>
                        <CardHeader>
                            <h2 className="mb-0 main-color">{`Performance`}</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Power Bhp`} value={vehicle && vehicle.features?.power_bhp ? `${vehicle.features.power_bhp}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Power Kw`} value={vehicle && vehicle.features?.power_kw ? `${vehicle.features.power_kw}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Peak power`} value={vehicle && vehicle.features?.power_rpm ? `${vehicle.features.power_rpm}rpm` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Torque FtLb`} value={vehicle && vehicle.features?.torque_ftlb ? `${vehicle.features.torque_ftlb}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Torque Nm`} value={vehicle && vehicle.features?.torque_nm ? `${vehicle.features.torque_nm}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Peak Torque`} value={vehicle && vehicle.features?.torque_rpm ? `${vehicle.features.torque_rpm}rpm` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Max speed`} value={vehicle && vehicle.features?.max_speed_mph ? `${vehicle.features.max_speed_mph}mph` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Max speed`} value={vehicle && vehicle.features?.max_speed_kph ? `${vehicle.features.max_speed_kph}kph` : ` `} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} sm={12}>
                    <Card>
                        <CardHeader>
                            <h2 className="mb-0 main-color">{`Engine technical`}</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Cylinders`} value={vehicle && vehicle.features?.cylinders ? `${vehicle.features.cylinders}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Valves/cyl`} value={vehicle && vehicle.features?.valves_per_cyl ? `${vehicle.features.valves_per_cyl}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Stroke`} value={vehicle && vehicle.features?.stroke ? `${vehicle.features.stroke}mm` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Bore`} value={vehicle && vehicle.features?.bore ? `${vehicle.features.bore}mm` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Arrangement`} value={vehicle && vehicle.features?.arrangement ? `${vehicle.features.arrangement}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Cam type`} value={vehicle && vehicle.features?.cam_type ? `${vehicle.features.cam_type}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Engine location`} value={vehicle && vehicle.features?.engine_location ? `${vehicle.features.engine_location}` : ` `} />
                                </Col>
                                <Col md={3} sm={12}>
                                    <VerticalLabel label={`Aspiration`} value={vehicle && vehicle.features?.aspiration ? `${vehicle.features.aspiration}` : ` `} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} sm={12}>
                    <Card>
                        <CardHeader>
                            <h2 className="mb-0 main-color">{`Mot & Tax data`}</h2>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md={6} sm={12}>
                                    <VerticalLabel label={`Next mot due date`} value={vehicle && vehicle.administrative?.mot_date ? moment(vehicle.administrative.mot_date).format('DD/MM/YYYY') : ` `} />
                                </Col>
                                <Col md={6} sm={12}>
                                    <VerticalLabel label={`Days until next mot is due`} value={vehicle && vehicle.administrative?.mot_date ? moment(vehicle.administrative.mot_date).diff(moment(), 'days') : ` `} />
                                </Col>
                                <Col md={6} sm={12}>
                                    <VerticalLabel label={`Ved expiry date`} value={vehicle && vehicle.administrative?.rfl_taxed_date ? moment(vehicle.administrative.rfl_taxed_date).format('DD/MM/YYYY') : ` `} />
                                </Col>
                                <Col md={6} sm={12}>
                                    <VerticalLabel label={`Ved days remaining`} value={vehicle && vehicle.administrative?.rfl_taxed_date ? moment(vehicle.administrative.rfl_taxed_date).diff(moment(), 'days') : ` `} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Row>

                <Col md={12}>
                    <ButtonContainer reverse={true}
                                     onClick={() => {
                                         setUpdateVehicleEnable(false)
                                         updateVehicle(vehicle, () => {
                                             setUpdateVehicleEnable(true)
                                         })
                                     }} disabled={!updateVehicleEnable}>Save</ButtonContainer>
                </Col>
            </Row>
        </CardBody>
    );
};

export default VehicleDetails;
